import { useGlobalContext } from "../../contexts/globalContext";
import { useCallback, useContext, useMemo, useState } from "react";
import { useFormContext } from "../../contexts";

interface IResponseData {
  asset_description: string;
  asset_number: number;
}

export default function searchListActives() {
  const { watchFields, setValue } = useFormContext();
  const [responseData, setResponseData] = useState<IResponseData[] | null>(
    null
  );

  const { _listActives } = useGlobalContext()

  const searchValue = watchFields["searchListActives"];
  const listActives = _listActives
  const filteredData = listActives?.filter(
    (item) =>
      item?.asset_number.includes(searchValue) ||
      item?.asset_description.includes(searchValue?.toUpperCase())
  );

  const handleFilterData = useCallback(() => {
    setResponseData(filteredData);
  }, []);

  useMemo(() => {
    if (searchValue) {
      setResponseData(filteredData);
    }
  }, [searchValue]);

  return {
    setResponseData,
    listActives,
    handleFilterData,
    responseData,
  };
}